export type ApiEnv = 'develop' | 'staging' | 'production';

export interface CognitoPoolConfig {
  REGION: string;
  USER_POOL_ID: string;
  APP_CLIENT_ID: string;
}

/** Cognito user pool config per environment (source of truth for Discover SPAs). */
export const COGNITO_POOLS: Record<ApiEnv, CognitoPoolConfig> = {
  develop: {
    REGION: 'us-west-2',
    USER_POOL_ID: 'us-west-2_6muGdsKW7',
    APP_CLIENT_ID: '2spgm4spigd4nkgss20d8at0e2',
  },
  staging: {
    REGION: 'us-west-2',
    USER_POOL_ID: 'us-west-2_XHP55nas3',
    APP_CLIENT_ID: '6nptii12amhch6pjumc771iq2a',
  },
  production: {
    REGION: 'us-west-2',
    USER_POOL_ID: 'us-west-2_F780PZz6B',
    APP_CLIENT_ID: '2li68vcdmu4ha4u02u0i4ob1pe',
  },
};

export const getCognitoConfig = (apiEnv: string): CognitoPoolConfig => {
  const env = apiEnv as ApiEnv;
  return COGNITO_POOLS[env] ?? COGNITO_POOLS.develop;
};
